// src/services/data_service.js
const API_BASE_URL = 'https://stats.portal.africa/api/road-stats';

export const fetchTransportModes = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/transport-modes`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching transport modes:', error);
        throw error;
    }
};

export const fetchFeatures = async (transportMode) => {
    try {
        const response = await fetch(`${API_BASE_URL}/features?transport_mode=${transportMode}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching features:', error);
        throw error;
    }
};

export const fetchYears = async (transportMode, feature) => {
    try {
        const response = await fetch(`${API_BASE_URL}/years?transport_mode=${transportMode}&feature=${feature}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching years:', error);
        throw error;
    }
};

export const fetchFilteredData = async (transportMode, feature, year) => {
    try {
        const response = await fetch(`${API_BASE_URL}/data?transport_mode=${transportMode}&feature=${feature}&year=${year}`);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return await response.json();
    } catch (error) {
        console.error('Error fetching filtered data:', error);
        throw error;
    }
};
